const copyTextToClipboard = async (stringToCopy: string) => {
  try {
    await navigator.clipboard.writeText(stringToCopy)
  } catch (err) {
    console.error('Failed to copy text: ', err)
  }
}

export default copyTextToClipboard
